<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" sm="12" align="center">
        <v-img src="@/assets/ipad.png" position="center center" contain></v-img>
      </v-col>

      <v-col cols="12" md="6" sm="12">
        <div class="text-outline teal-text-dark">New</div>
        <div class="text-h3 font-weight-bold">Apple iPad Pro 12.9"</div>
        <v-divider class="my-5"></v-divider>
        <div class="text-h5 font-weight-black">{{ currency }}{{ amount }}</div>
        <v-divider class="my-5"></v-divider>

        <div>
          The ultimate iPad just got a serious upgrade. Supercharged by Apple’s
          M2 processor, the 12.9” 2022 iPad Pro delivers astonishing
          performance, an amazingly advanced display, and stunning speed.
        </div>

        <v-divider class="my-5"></v-divider>

        <div class="text-body-2">
          <div class="pb-2">
            <v-icon small class="pr-2">mdi-circle-medium</v-icon>12.9-inch iPad
            Pro
          </div>
          <div class="pb-2">
            <v-icon small class="pr-2">mdi-circle-medium</v-icon>Space Grey
          </div>
          <div class="pb-2">
            <v-icon small class="pr-2">mdi-circle-medium</v-icon>2TB Internal
            Memory
          </div>
          <div class="pb-2">
            <v-icon small class="pr-2">mdi-circle-medium</v-icon>Supercharged by
            M2
          </div>
          <div>
            <v-icon small class="pr-2">mdi-circle-medium</v-icon>5G speed
          </div>
        </div>

        <v-divider class="my-5"></v-divider>

        <v-btn
          @click="addToBasket"
          dark
          tile
          block
          elevation="0"
          large
          color="#2dc59a"
          >Go to Cart</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      currency: process.env.VUE_APP_CURRENCY === 'GBP' ? '£' : '€',
      amount: process.env.VUE_APP_AMOUNT
    };
  },
  methods: {
    addToBasket() {
      this.$emit("addToBasket");
    },
  },
};
</script>

<style>
</style>